// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mv-0";
export var leftAlign = "_mv-4";
export var listItem = "_mv-2";
export var listItemWrapper = "_mv-1";
export var operationText = "_mv-3";